import BaseRepository from './base.repository';

class PatientRepository extends BaseRepository {
  constructor() {
    super('/general-code');
  }

  getAll(conditions) {
    return this.client.get('/patients/options', conditions);
  }
}

export default new PatientRepository();
